import {
  SET_BANK_BRANCH_CODE,
  SET_LEAD_SELECTED_ITEMS,
} from '@stores/lead/constants.js';

export const initialState = {
  bankBranchData: [],
};

const leadReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_BANK_BRANCH_CODE:
      state = {
        ...state,
        bankBranchData: payload,
      };

      break;
    case SET_LEAD_SELECTED_ITEMS:
      state = {
        ...state,
        leadSelectedItem: payload,
      };
      break;
    default:
      break;
  }
  return state;
};

export default leadReducers;
